<template>
  <div id="survey-overview">
    <div class="row">
      <div class="col s12">
        <div class="title-area">Wind Hazard Assessment</div>
        <div class="col s12">
       <!--  Can your home withstand the winds of a Category 5 hurricane? Find out here by telling us a bit more about the type, construction and condition of your home’s roof, windows, doors, walls and foundation.  -->
       	<p>
           Can your home withstand the winds of a Category 5 hurricane? Find out here by telling us a bit more about the type, construction and condition of your home’s roof, windows, doors, walls and foundation.
         </p>
         
	    	<p>
          The results of the assessment will be used to estimate the expected impact level to your home from Category 5 hurricane-force winds.
        </p>
 
        </div>
      </div>
    </div>
    <div class="row flex-row">
      <div class="col s6" v-for="(tool, index) in tools" :key="index">
        <div class="card hoverable">
          <div class="card-content">
            <div class="icon-area"  @click="$_goToStep(tool.toIndex, tool.toStep)">
              <img :src="tool.icon">
            </div>
            <div  @click="$_goToStep(tool.toIndex, tool.toStep)" class="card-title indigo-text text-accent-5">
              {{tool.name}}
            </div>
            <div class="current-status">
        <!--     <span v-if="tool.toStep === 'roof'"> {{ roofStatusX }} </span>
            <span v-if="tool.toStep === 'windows_doors'"> {{ windowStatusX }} </span>
            <span v-if="tool.toStep === 'walls_foundations'"> {{ wallStatusX }} </span> -->
            </div>
          </div>
          <div class="action-container">
            <div class="card-action">
              <button
                class="btn btn-rounded indigo accent-5 waves-effect"
                @click="$_goToStep(tool.toIndex, tool.toStep)"
              >
                <span v-if="tool.toStep === 'roof'"> {{ roofStatusX }} </span>
                <span v-else-if="tool.toStep === 'windows_doors'"> {{ windowStatusX }} </span>
                <span v-else-if="tool.toStep === 'walls_foundations'"> {{ wallStatusX }} </span>
                <span v-else>Review</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import windows_doors from '@/assets/window_svg_.svg'
import roofing from '@/assets/roofing_svg.svg'
import walls_foundations from '@/assets/walls_foundation_.svg'
import { schema } from '@/schemas/windHazard.js'
import overview_icon from '@/assets/overview_icon.svg'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'SurveyOverview',
  props: {},
  data () {
    return {
      tools:[
        {
          icon: roofing,
          name: 'Roof',
          buttonText: 'Start',
          toIndex: 1,
          toStep: 'roof'
        },
        {
          icon: windows_doors,
          name: 'Windows and Doors',
          buttonText: 'Start',
          toIndex: 2,
          toStep: 'windows_doors'
        },
        {
          icon: walls_foundations,
          name: 'Walls and Foundation',
          buttonText: 'Start',
          toIndex: 3,
          toStep: 'walls_foundations'
        },
        {
          icon: overview_icon,
          name: 'Expected Impact Level',
          buttonText:'Start',
          toIndex: 4,
          toStep: ''
        },

      ]
    };
  },
  mounted() {
    // console.log(this.windHazard);
  },
  computed: {
    ...mapState({
      windHazard: (state) => state.Surveys.windHazard,
      user: state => state.User.user,
    }),
    homeProfile: {
      get () {
        return this.user.home_profile
        ? JSON.parse(this.user.home_profile)
        : false
      }
    },
    roofQuestionsX() {
      if (this.windHazard && this.windHazard.survey) {
        const val = Object.keys(schema).reduce((result, key) => {
          if (schema[key].section && schema[key].section === "roof") {
            result[key] = this.windHazard.survey[key];
          }
          return result;
        }, {});

        return val;
      }
      return {};
    },
    roofStatusX() {
      const hasBegan = Object.values(this.roofQuestionsX).some((item) => {
        if (typeof item === "object") {
          return item.length > 0 ? true : false;
        } else {
          return !!item;
        }
      });

      return hasBegan ? "Continue" : "Begin";
    },
    windowQuestionsX() {
      if (this.windHazard && this.windHazard.survey) {
        const val = Object.keys(schema).reduce((result, key) => {
          if (schema[key].section && schema[key].section === "window") {
            result[key] = this.windHazard.survey[key];
          }
          return result;
        }, {});

        return val;
      }
      return {};
    },
    windowStatusX() {
      const hasBegan = Object.values(this.windowQuestionsX).some((item) => {
        if (typeof item === "object") {
          return item.length > 0 ? true : false;
        } else {
          return !!item;
        }
      });

      return hasBegan ? "Continue" : "Begin";
    },
    wallQuestionsX() {
      if (this.windHazard && this.windHazard.survey) {
        const val = Object.keys(schema).reduce((result, key) => {
          if (schema[key].section && schema[key].section === "wall") {
            result[key] = this.windHazard.survey[key];
          }
          return result;
        }, {});

        return val;
      }
      return {};
    },
    wallStatusX() {
      const hasBegan = Object.values(this.wallQuestionsX).some((item) => {
        if (typeof item === "object") {
          return item.length > 0 ? true : false;
        } else {
          return !!item;
        }
      });

      return hasBegan ? "Continue" : "Begin";
    },
  },
  methods: {
    ...mapActions("Helpers", ["setHelper"]),
    $_goToStep(step, section) {
      this.$router.push({query:{editing:true, section:step, step:step}})
      this.$emit("updateStep", { step, section });
      try {
        let oldHistory = localStorage.getItem('stepHistory')
        if(oldHistory) {
          let newBlock = JSON.parse(oldHistory)
          let blankObject = {...newBlock}
          blankObject[this.$route.name.toLowerCase()] =  {
                route:this.$route.name,
                step: step,
                timeStamp: new Date()
              }
          localStorage.setItem('stepHistory',JSON.stringify(blankObject))

        } else {
             let newBlock = {}
          let blankObject = {...newBlock}
          blankObject[this.$route.name.toLowerCase()] =  {
                route:this.$route.name,
                step: step,
                timeStamp: new Date()
              }
          localStorage.setItem('stepHistory',JSON.stringify(blankObject))
        }
      } catch (error) {
        let newBlock = {}
          let blankObject = {...newBlock}
          blankObject[this.$route.name.toLowerCase()] =  {
                route:this.$route.name,
                step: step,
                timeStamp: new Date()
              }
          localStorage.setItem('stepHistory',JSON.stringify(blankObject))
        return error
      }
    },
  },
};
</script>
<style scoped lang="scss">
#survey-overview {
  padding: 16px;
  @media screen and (min-width: 1024px) {
    max-width: 768px;
    margin: auto;
  }
  .row {
    &.flex-row {
      display: flex;
      flex-wrap: wrap;
      .col {
        float: none;
        margin-left: 0px;
        margin-right: 0px;
      }
    }
  }
  .card {
    height: calc(100% - 1.5rem);
      .card-title {
        font-size: 18.5px;
        font-weight: 500;
        line-height: 20.5px;
        margin-top: 4px;
        margin-bottom: 4px;
      }
      .action-container {
        height: 58px;
        width: 100%;
        .card-action {
            padding-top: 0px;
            position: absolute;
            bottom: 0; left: 0; right: 0;
            border: none;
            width: 100%;
            button {
              width: 100%;
            }
          }
      }
  }
  .title-area {
    font-size: 26px;
    margin: 12px 8px 2px;
    position: relative;
/*     &::before {
      content: 'Select an option below to begin';
      font-size: 13px;
      position: absolute;
      left: 2px;
      bottom: -16px;
    } */
  }
  .icon-area {
    img {
      height: 75px;
    }
    margin-bottom: 12px;
  }
}
</style>
